// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Button = require('share/components/controls/Izenda.Button');
  var constants = require('logic/data/Izenda.ImportDataModelConstants');
  var observer = require('mobx-react').observer;

  /*
  * Header Component
  */
  var MappingHeader = React.createClass({
    propTypes: {
      addMapping : PropTypes.func.isRequired,
      localization: PropTypes.object.isRequired
    },
 
    render: function () {
      var props = this.props;
      var localization = props.localization;
      var addMapping = props.addMapping;
      var headerText =  constants.MAPPING_HEADER.TENANT;
      var mappingTooltip = constants.MAPPING_HEADER.SPECIFIC_MAPPING_TOOLTIP;

      return (
        <GridLayout>
          <GridLayout.Row className='u_table u_fullWidth'>
            <GridLayout.Col
              cols={2}
              className='u_tableCell u_alignMiddle text-bold u_floatNone'>
              {headerText}
              <span className='icon-info-circled' title={mappingTooltip}></span>
            </GridLayout.Col>  
            <GridLayout.Col
              cols={7}
              className='u_tableCell u_alignMiddle pull-right text-right'>
              <Button
                label={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADD_MAPPING')}
                onClick={addMapping}>
              </Button>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    } 
  });

  module.exports = observer(MappingHeader);
} ();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/AdvancedImport/Mapping/Izenda.MappingHeader.jsx